import { InputField } from "@/components/common/input";
import { firstNameField, secondNameField } from "@/pages/quiz/base/questions/contactField/validationRules";
import { validateDob } from "@/utils/validateField/dob";
import { Button, ButtonType } from "@/components/common/button";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { useManageInputFields } from "@/pages/quiz/hooks/useManageInputFields";

type FormFieldName = "firstName" | "lastName" | "dob";
type ContactFieldsValues = Record<FormFieldName, string>;

// Define the validation fields and their properties
const validationFields = {
  firstName: firstNameField,
  lastName: secondNameField,
  dob: {
    customValidator: (v: string) => validateDob(v || ""),
    required: true,
  },
};

const ContactFullNameDob = ({
  questionValue,
  setQuestionValue,
  setQuestionAnswer,
}: QuizQuestionProps<ContactFieldsValues>) => {
  const { registerField, error } = useManageInputFields(
    {
      setQuestionValue,
      questionValue,
    },
    validationFields
  );

  const isNoErrors = Object.values(error).every(
    (errorMessage) => !errorMessage
  );

  const isAllAnswered =
    Object.values(questionValue).filter(Boolean).length === 3;

  const isFormAnswered = isAllAnswered && isNoErrors;

  const onSubmit = async () => {
    if (isFormAnswered) {
      setQuestionAnswer(questionValue);
    }
  };

  return (
    <>
      <div className="w-full flex-col flex gap-4">
        <InputField {...registerField("firstName")} label="First name" />
        <InputField {...registerField("lastName")} label="Last name" />
        <InputField
          {...registerField("dob")}
          label="Date of birth"
          type="dob"
          placeholder="MM/DD/YYYY"
        />
      </div>
      <Button
        type={ButtonType.CONTINUE}
        disabled={!isFormAnswered}
        onClick={onSubmit}
      />
    </>
  );
};

export { ContactFullNameDob };
